import CartAddButton from './AddButton'
import CartViewButton from './ViewButton'

export default function Components(Vue) {
  Vue.component('cart-add-button', CartAddButton)
  Vue.component('cart-view-button', CartViewButton)
}
